import { useMemo } from 'react';
import { useClock } from '@/hooks/useClock';
import type { LanguageCode } from '@/types';

interface DateTimeWidgetProps {
  lang: LanguageCode;
}

const LOCALE_MAP: Record<LanguageCode, string> = {
  hu: 'hu-HU',
  en: 'en-GB',
  de: 'de-DE',
};

export function DateTimeWidget({ lang }: DateTimeWidgetProps) {
  const now = useClock();
  const locale = LOCALE_MAP[lang] ?? 'hu-HU';

  const time = useMemo(
    () => new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' }).format(now),
    [now, locale],
  );
  const date = useMemo(
    () =>
      new Intl.DateTimeFormat(locale, { weekday: 'long', day: 'numeric', month: 'long' }).format(now),
    [now, locale],
  );

  return (
    <div className="flex flex-col items-center leading-none select-none">
      <span className="font-display font-light text-xl kiosk:text-kiosk-xl tabular-nums tracking-tight text-kiosk-text">
        {time}
      </span>
      <span className="text-[0.65rem] kiosk:text-kiosk-xs text-kiosk-muted capitalize mt-1 kiosk:mt-[0.4vw] truncate max-w-[26vw] kiosk:max-w-none">
        {date}
      </span>
    </div>
  );
}
